import { render } from "./Strip.vue?vue&type=template&id=3e5b9702"
import script from "./Strip.vue?vue&type=script&lang=js"
export * from "./Strip.vue?vue&type=script&lang=js"

import exportComponent from "C:\\bipom\\VSVN\\dude\\Web\\SmartLamp\\2.03\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__